export const getRevalidateTimeout = (
  defaultRevalidate: number,
): number | false | undefined => {
  const environmentOverride = process.env.CACHE_REVALIDATE;

  try {
    let environmentOverrideInt = -1;

    if (environmentOverride) {
      environmentOverrideInt = parseInt(environmentOverride);
    }
    if (environmentOverrideInt === 0) {
      return 1; // if cache invalidate is 0, make it expire after 1 second instead of never
    }
    if (environmentOverrideInt > 0) {
      return environmentOverrideInt;
    }
  } catch (error) {
    console.error('Failed to parse CACHE_REVALIDATE');
  }
  return defaultRevalidate;
};
